import { get } from '@/jsUtils/nodejsRequest'
import { Product_Info } from '@/globalcfg'

function buildFallbackList() {
    const fallback = []
    const keys = Object.keys(Product_Info)
    const total = keys.length
    keys.forEach((key, index) => {
        const item = Product_Info[key]
        const slug = (item.key || item.path || key).toLowerCase()
        fallback.push({
            id: item.key || key,
            slug,
            name: {
                zh: item.show_name_zh || item.show_name || '',
                en: item.show_name || item.show_name_zh || ''
            },
            summary: {
                zh: '',
                en: ''
            },
            coverImage: item.image_path,
            isNew: false,
            templateType: 'custom',
            customComponent: slug,
            customUrl: null,
            priority: total - index,
            categories: []
        })
    })
    return fallback
}

function findFallbackDetail(slug) {
    const matched = Object.keys(Product_Info).find(key => {
        const item = Product_Info[key]
        const keySlug = (item.key || item.path || key).toLowerCase()
        return keySlug === slug.toLowerCase()
    })
    if (!matched) {
        return null
    }
    const item = Product_Info[matched]
    return {
        id: item.key || matched,
        slug: (item.key || item.path || matched).toLowerCase(),
        status: 'published',
        templateType: 'custom',
        name: {
            zh: item.show_name_zh || item.show_name || '',
            en: item.show_name || item.show_name_zh || ''
        },
        defaultTemplate: null,
        customComponent: (item.key || item.path || matched).toLowerCase(),
        customData: {
            legacy: true
        },
        attachments: [],
        lastUpdated: null
    }
}

const API_PREFIX = '/imageprocesshost';

export async function fetchProductList(lang) {
    try {
        const response = await get(API_PREFIX + '/api/products', { lang })
        if (response && Array.isArray(response.data)) {
            return response.data
        }
    } catch (error) {
        console.warn('[products] fetchProductList failed, fallback to legacy data', error)
    }
    return buildFallbackList()
}

export async function fetchProductDetail(slug, lang) {
    try {
        const response = await get(API_PREFIX + `/api/products/${slug}`, { lang })
        if (response && response.data) {
            return response.data
        }
    } catch (error) {
        console.warn('[products] fetchProductDetail failed, fallback to legacy component', slug, error)
    }
    const fallback = findFallbackDetail(slug)
    if (fallback) {
        return fallback
    }
    throw new Error('PRODUCT_NOT_FOUND')
}
